import { ref, computed } from '@vue/composition-api'
import CheckInSettingsApi from '@/api/waiter/CheckInSettings'

// 出勤時の申告の設定(その店舗に当てはまる設定)。
// 出勤時刻の計算式は画面に持たず、必ずサーバーに問い合わせる
export default () => {
  const checkInSettings = ref({ timeRuleEnabled: false, items: [] })

  const declarationItems = computed(() => checkInSettings.value.items || [])
  const hasDeclarationItems = computed(() => declarationItems.value.length > 0)
  const isTimeRuleEnabled = computed(() => !!checkInSettings.value.timeRuleEnabled)

  const getCheckInSettings = async () => {
    try {
      const res = await CheckInSettingsApi.getCheckInSettings()
      if (res?.data?.checkInSettings) checkInSettings.value = res.data.checkInSettings
    } catch (error) {
      // 取得できなくても打刻は従来どおり使えるようにする
      checkInSettings.value = { timeRuleEnabled: false, items: [] }
    }
  }

  // そのキャストがその営業日にすでに申告した「1営業日に1回まで」の項目の ID。失敗したら空
  const getDeclaredTodayItemIds = async ({ userId, date = null, exceptTimecardId = null }) => {
    if (!userId) return []
    try {
      const res = await CheckInSettingsApi.getCheckInSettings({ userId, date, exceptTimecardId })

      return res?.data?.checkInSettings?.declaredTodayItemIds || []
    } catch (error) {
      return []
    }
  }

  // 失敗したら null(画面は出勤時刻を出さない)
  const calculateStartAt = async ({ punchedAt = null, timecardId = null, declarationItemIds = [] }) => {
    try {
      const res = await CheckInSettingsApi.calculate({ punchedAt, timecardId, declarationItemIds })

      return res?.data || null
    } catch (error) {
      return null
    }
  }

  return {
    checkInSettings,
    declarationItems,
    hasDeclarationItems,
    isTimeRuleEnabled,
    getCheckInSettings,
    getDeclaredTodayItemIds,
    calculateStartAt,
  }
}
